var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item-image"},[(_vm.isPdf)?_c('app-proxy-pdf',{ref:"renderer",staticClass:"file-image__pdf",attrs:{"src":_vm.imgSrc}}):_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:({
      src: _vm.imgSrc,
      loading: _vm.defaultProductImage,
      error: _vm.defaultProductImage,
    }),expression:"{\n      src: imgSrc,\n      loading: defaultProductImage,\n      error: defaultProductImage,\n    }"}],staticStyle:{"object-fit":"cover"},style:(_vm.heightOfImage),on:{"load":function($event){return _vm.$redrawVueMasonry()}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }